module.exports = __webpack_public_path__ + "img/icon-shejiqiye.ec11a47f.jpg";